import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {validate as validateEmail} from "email-validator";
// data
import Config from "../../config";
import data from "../../data";
// components & icons
import {ExternalLink, Loader} from "../controls/";
import {faInstagram, faFacebookF, faLinkedinIn} from "@fortawesome/free-brands-svg-icons";
// styling
import "./Footer.scss";

const links = {
  primary: [
    Config.links.faq,
    Config.links.howItWorks,
    Config.links.about
  ],
  secondary: [
    Config.links.contact, 
    Config.links.imprint,
    Config.links.dataProtection
  ]
}

function Footer() {
  // render
  return <footer>
    <div id="v-footer">
      <div id="v-footer-inner">
        <div id="v-footer-left">
          <PrimaryLinks />
          <Contact />
        </div>

        <div id="v-footer-right">
          <Social />
          <PaymentProviders />
          <Newsletter />
          <SecondaryLinks />
        </div>
      </div>
    </div>
  </footer>
}

function PrimaryLinks() {
  const primaryLinks = links.primary.map((link, index) => <div key={index} className="item"><ExternalLink to={link.href} className="green-hover">{link.label}</ExternalLink></div>);
  return (
    <div id="v-footer-links-primary">
      {primaryLinks}
    </div>
  );
}

function SecondaryLinks() {
  const secondaryLinks = links.secondary.map((link, index) => <div key={index} className="item"><ExternalLink to={link.href}>{link.label}</ExternalLink></div>);
  return (
    <div id="v-footer-links-secondary">
      {secondaryLinks}
    </div>
  )
}

function Contact() {
  return (
    <div id="v-footer-contact">
      <div id="v-footer-contact-address">
        <div>Appentura AG</div>
        <div>Bernapark 28</div>
        <div>3066 Stettlen / Bern</div>
      </div>
      <div id="v-footer-contact-phone">
        <a href="tel:+41 31 511 21 32">+41 31 511 21 32</a>       
      </div>
      <div id="v-footer-contact-email">
        <a href="mailto:hello@appentura.ch" className="green-hover">hello@appentura.ch</a>
      </div>
    </div>
  )
}

function Social() {
  return (
    <div id="v-footer-social">
      <div id="v-footer-social-follow">
        <div className="label">Follow</div>
        <SocialMediaButton name="instagram" icon={faInstagram} href="https://www.instagram.com/appentura" />
        <SocialMediaButton name="facebook" icon={faFacebookF} href="https://de-de.facebook.com/appentura" />
      </div>
      <div id="v-footer-social-connect">
        <div className="label">Connect</div>
        <SocialMediaButton name="linkedin" icon={faLinkedinIn} href="https://www.linkedin.com/company/appentura" />
      </div>
    </div>
  )
}

function PaymentProviders() {
  const items = Config.paymentProviders.map((pp, index) => {
    return <div key={index}><img key={index} src={pp.image} alt={pp.name} /></div>
  })
  return (
    <div id="v-footer-paymentproviders">
      <div id="v-footer-paymentproviders-heading">Zahlungsoptionen</div>
      <div id="v-footer-paymentproviders-icons">{items}</div>
    </div>
  )
}

function Newsletter() {
  // state management
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterEmailValid, setNewsletterEmailValid] = useState(false);
  const [didSubscribe, setDidSubscribe] = useState(false);
  const [isBusy, setIsBusy] = useState(false);

  // handles changes to the newsletter e-mail textinput
  const onNewsletterEmailChange = (e) => {
    let email = e.target.value
    let valid = validateEmail(email.trim())
    setNewsletterEmail(email)
    setNewsletterEmailValid(valid)
  }

  // handles clicks on the newsletter subscribe button
  const onClickNewsletterSubscribe = async(e) => {
    if(e.preventDefault) { 
      e.preventDefault();
    }
    if(newsletterEmailValid) {
      setIsBusy(true);
      await data.Newsletter.subscribe(newsletterEmail);
      setNewsletterEmail("");
      setNewsletterEmailValid(false);
      setIsBusy(false);
      setDidSubscribe(true);  
    }
  }

  // render
  let content = null;
  if(isBusy) {
    content = <>
      <div className="newsletter-explanation">Danke ... ich verarbeite deine Eingabe</div>
      <div className="newsletter-form"><Loader /></div>
    </>
  }
  else if(didSubscribe) {
    content = <>
      <div className="newsletter-explanation">Vielen Dank, dass du dich für unseren Newsletter angemeldet hast - wir freuen uns schon darauf, unsere Freude am Schenken mit dir zu teilen :)</div>
    </>
  }
  else {
    content = <>
      <div className="newsletter-explanation">Abonniere unseren Newsletter und profitiere von exklusiven Angeboten:</div>
      <div className="newsletter-form">
        <input type="text" placeholder="Deine E-Mail Adresse" onChange={onNewsletterEmailChange} value={newsletterEmail} />
        <div className="newsletter-button" onClick={onClickNewsletterSubscribe}>Anmelden</div>
      </div>
    </>
  }
  return (
    <div id="v-footer-newsletter">
      {content}
    </div>
  )
}

function SocialMediaButton({icon, href, name}) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <div className="social-media-button">
        <div className="inner">
          <div className="icon-outer">
            <FontAwesomeIcon className={`icon ${name}`} icon={icon} />
          </div>
        </div>
      </div>
    </a>
  )
}

export default Footer;
